/**
 * `toLocaleDateString('ar', …)` wraps each part of a date in right-to-left marks (U+200F), so "2024/06/02 -> 2026/06/30"
 * inside a `dir="ltr"` span still came out reordered on Arabic screens (seen on the contract header, 2026-09-22).
 * Dates are digits and separators: with the marks removed they read the same in either direction, and the
 * surrounding element decides the order.
 */
export const stripBidiMarks = (s: string): string => s.replace(/[‎‏؜]/g, '');
